import { useI18n } from '../i18n';

// Release 4b's more prominent safety element for the card-deck check-in:
// same content contract as SafetyNet (the school's own text, else the
// generic message — never behind a condition on the mood value), but
// rendered once in the deck's frame, sticky above the card, so it stays on
// screen across every step instead of appearing once below the card.
export function HelpStrip({ message, safetyValve }: { message?: string | null; safetyValve?: boolean }) {
  const { t } = useI18n();
  return (
    <aside className="sx-helpstrip" aria-label={t['safety.label']}>
      <span className="icon" aria-hidden="true">💛</span>
      <p>{message?.trim() || (safetyValve ? t['r6.ci.safetyNetMessage'] : t['safety.message'])}</p>
    </aside>
  );
}
